(function() {
  var BaseController,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  BaseController = App.loadClass('core::Angular/UsernameDropdown/BaseController');

  exports.BackgroundController = (function(superClass) {
    extend(BackgroundController, superClass);

    function BackgroundController(scope, transitions, modalInstance, repo, user, options) {
      this.scope = scope;
      this.transitions = transitions;
      this.modalInstance = modalInstance;
      this.repo = repo;
      this.toggleCheckBox = bind(this.toggleCheckBox, this);
      this.save = bind(this.save, this);
      BackgroundController.__super__.constructor.call(this, this.scope, this.transitions, this.modalInstance, this.repo);
      this.scope.title = 'Edit Background';
      this.scope.user = user;
      this.scope.areas_of_expertise = _.chunk(options.expertise, 2);
      this.scope.professions = options.professions;
      this.scope.toggleCheckBox = this.toggleCheckBox;
    }

    BackgroundController.prototype.save = function() {
      this.scope.setAlert({
        msg: 'Saving Background...',
        type: 'info'
      });
      this.scope.user.expertise_ids = _.filter(this.scope.user.expertise_ids, (function(_this) {
        return function(id) {
          return id !== '';
        };
      })(this));
      return this.repo.saveBackground(this.scope.user).then((function(_this) {
        return function(response) {
          var jsr;
          jsr = response.data;
          return _this.closeWithAlert(jsr.status, jsr.data);
        };
      })(this));
    };

    BackgroundController.prototype.toggleCheckBox = function(id) {
      var index;
      index = this.scope.user.expertise_ids.indexOf(id);
      if (index === -1) {
        return this.scope.user.expertise_ids.push(id);
      } else {
        return this.scope.user.expertise_ids.splice(index, 1);
      }
    };

    return BackgroundController;

  })(BaseController);

}).call(this);
